export const EMPTY_ASSET_HINTS = {
  headline: _TL_('You must enter a Short headline to get asset recommendations. '),
  description: _TL_('You must enter a Description to get asset recommendations. '),
  longHeadline: _TL_('You must enter a Long headline to get asset recommendations. '),
};
export const NO_FINAL_URL_HINT = _TL_('You must enter a Final URL to get asset recommendations.');
export const REVISE_ERR_MSG = _TL_('We\'re not able to generate an asset from the provided text. Please enter a new description and try again.');
export const DIFFERENT_TONE_ERR_MSG = _TL_('We don\'t have a recommendation in this tone.');
export const FIND_SIMILAR_ERR_MSG = _TL_('There are no more recommendations.');
export const NOT_SUPPORT_DYNAMIC_TEXT = _TL_('Microsoft Advertising can\'t use dynamic texts for generating asset recommendations. Please enter static text and try again.');

export const POST_ASSET_EVENT_NAME = 'PostAssetGroupEvent';

export const POST_ASSET_LIBRARY_EVENT_NAME = 'PostAssetLibraryEvent';

export const AssetLibraryEventRecordType = {
  ENTER_ASSET_LIBRARY: 'EnterAssetLibrary',
  ENTER_GENERATE_IMAGES_PANEL: 'EnterGenerateImagesPanel',
  GENERATE_IMAGES: 'GenerateImages',
  RETURN_IMAGES: 'ReturnImages',
  ADD_IMAGES_TO_ASSET_LIBRARY: 'AddImagesToAssetLibrary',
};

export const AssetEventRecordType = {
  ENTER_FLOW: 'EnterFlow',
  RETURNED: 'Returned',
  VIEWED: 'Viewed',
  APPLIED: 'Applied',
  FEATURE_USAGE: 'FeatureUsage',
  MAPPING: 'Mapping',
};

export const AssetEventOperationName = {
  NON_ITERATIVE: 'NonIterative',
  REFRESH_THEME: 'RefreshTheme',
  DIFFERENT_BACKGROUND: 'DifferentBackground',
  REWRITE: 'Rewrite',
  FIND_SIMILAR: 'FindSimilar',
  DIFFERENT_TONE: 'DifferentTone',
  FINAL_URL_RECOMMENDATION: 'FinalUrlRecommendation',
  PREFILL: 'Prefill',
};

export const AssetEventFeature = {
  RSA: 'RSA',
  PMAX: 'Pmax',
  PMAX_LITE: 'PmaxLiteSignup',
  DISPLAY_PLUS: 'DisplayPlus',
  MMA: 'MMA',
};

export const AssetType = {
  TEXT: 'Text',
  IMAGE: 'Image',
  THEME: 'Theme',
  VIDEO: 'Video',
};

export const AssetPropertyName = {
  IMAGE: 'Image',
  HEADLINE: 'Headline',
  DESCRIPTION: 'Description',
  LONG_HEADLINE: 'LongHeadline',
};

export const AssetEngagementEventName = {
  VIEW: 'View',
  ENTER: 'Enter',
  GENERATE: 'Generate',
  APPLY: 'Apply',
  PREFILL: 'Prefill',
  REMOVE_ASSETS: 'RemoveAssets',
  REMOVE_SINGLE_ASSET: 'RemoveSingleAsset',
  EDIT_SINGLE_ASSET: 'EditSingleAsset',
  AD_STRENGTH: 'AdStrength',
};
